import { ChangeDetectorRef, Component, OnInit, Optional, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseSiteService, CmsAddToCartComponent, EventService, GlobalMessageService, GlobalMessageType, isNotNullable, TranslatePipe } from '@spartacus/core';
import { CmsComponentData, CurrentProductService, ProductListItemContext, SpinnerComponent } from '@spartacus/storefront';
import moment from 'moment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UdxActiveCartFacade } from 'src/app/udxb2b/facade/udx-active-cart.facade';
import { Udxb2bCalendarFacade } from 'src/app/udxb2b/facade/udxb2b-calendar-facade';
import { UdxCurrentProductService } from 'src/app/udxb2b/services/udx-current-product.service';
import { UdxDataTransferService } from 'src/app/udxb2b/services/udx-data-transfer.service.service';
import { UdxGroupSalesService } from 'src/app/udxb2b/services/udx-group-sales.service';
import { groupSalesFieldDisabled, USJB2BPortalConfig } from 'src/app/udxb2b/shared/constant/storefront-config';
import { Udxb2bAddToCartComponent } from '../../add-to-cart/add-to-cart.component';
import { Udxb2bInventoryEvents } from '../../model/udxb2b-calendar-availability.model';
import { Udxb2bItemCounterComponent } from '../../item-counter/item-counter.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { AsyncPipe, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'udx-group-sales-product-addon',
    templateUrl: './group-sales-addon.component.html',
    styleUrls: ['./group-sales-addon.component.scss'],
    imports: [SpinnerComponent, ReactiveFormsModule, Udxb2bItemCounterComponent, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatProgressSpinnerModule, MatSelectModule, MatOptionModule, MatDividerModule, AsyncPipe, CurrencyPipe, TranslatePipe]
})
export class GroupSalesAddonComponent extends Udxb2bAddToCartComponent implements OnInit {
  groupRuleCartForm: UntypedFormGroup | undefined;
  override isDateSelectionDisabled = false;

  minDate: Date = new Date();
  maxDate: Date = new Date();
  formQuantityMap = new Map<string, number>();

  sub$ = new Subscription();
  updatedQuantityMap = new Map<string, number>();

  grpSubTotal$ = this.dataTransfer.groupRuleSubtotal$;
  grpSubTotalFormattedString$ = new BehaviorSubject('0');
  selectedVisitaionDate: string = '';

  baseSiteService = inject(BaseSiteService);
  hideFields = false;
  timeSlot: Set<string> = new Set<string>();
  grpSalesTimeSlot :Set<string> = new Set<string>();
  visitationDate = '';
  constructor(
    udxb2bCalendarFacade: Udxb2bCalendarFacade,
    currentProductService: CurrentProductService,
    private udxCurrentProductService: UdxCurrentProductService,
    protected dataTrasfer: UdxDataTransferService,
    cd: ChangeDetectorRef,
    activeCartService: UdxActiveCartFacade,
    component: CmsComponentData<CmsAddToCartComponent>,
    eventService: EventService,
    dialog: MatDialog,
    dataTransfer: UdxDataTransferService,
    private _router: Router,
    globalMessageService: GlobalMessageService,
    protected groupSales: UdxGroupSalesService,
    protected route: ActivatedRoute,
    _baseSiteService: BaseSiteService,
    @Optional() productListItemContext?: ProductListItemContext
  ) {
    super(
      udxb2bCalendarFacade,
      currentProductService,
      cd,
      activeCartService,
      component,
      eventService,
      dialog,
      dataTransfer,
      globalMessageService,
      _baseSiteService,
      productListItemContext
    );
    this.minDate = addOneDay();
    var date = new Date();
    this.maxDate = new Date(date.setMonth(date.getMonth() + 6));
  }

  override ngOnInit(): void {
    // this is overridden to create a different FormControl for addon.
    this.sub$.add(
    this.dataTransfer.addToCartButtonEnabled$.subscribe(val=>{
      this.isAddToCartDisabled = val;
    }));
    this.sub$.add(
    this.udxCurrentProductService
      .getGroupProduct()
      .pipe(filter(isNotNullable))
      .subscribe((product) => {
        this.productCode = product.code ?? '';
        this.product = product;
        this.visitationDate = product?.groupRuleVisitationDate ? product?.groupRuleVisitationDate : '';
        this.buildProductAddonForm();
        this.cd.markForCheck();
        this.dataTransfer.updateGroupRuleSubtotal(Number(this.product.groupSubTotal ? this.product.groupSubTotal : 0));
        if (this.product.groupSubTotal && this.product.groupRuleVisitationDate) {
          this.isAddToCartDisabled = false;
        }
        this.checkAndDisableDateSelection();
      }));

      this.sub$.add(
        this.baseSiteService.getActive().pipe(take(1)).subscribe((baseSite) => {
          groupSalesFieldDisabled
            .filter((config) => config.baseSiteId === baseSite)
            .map((config) => {
              this.hideFields = config.active;
            });

          USJB2BPortalConfig.filter((config) => config.baseSiteId === baseSite).map((config) => {
            this.usjfeature = config.active;
          });
        })
      );
  }

  resetDate() {
    this.dataTransfer.resetSelectedDate$.pipe(take(1)).subscribe((res) => {
      if (res) {
        this.groupRuleCartForm?.get('groupRuleDatePicker')?.reset();
        this.isAddToCartDisabled = true;
        this.dataTransfer.resetSelectedDate(false);
      }
    });
  }

  buildProductAddonForm() {
    const formGroupFields = this.getAddonFormControlsFields();
    this.groupRuleCartForm = new UntypedFormGroup(formGroupFields);
    const selectedDate = this.product.groupRuleVisitationDate;
    if (selectedDate && this.product?.dateSelectionRequired) {
      let restorationDate = new Date(selectedDate);
      this.groupRuleCartForm.get('groupRuleDatePicker')?.setValue(restorationDate);
      if (this.usjfeature){
      this.dateSelected({ value: restorationDate } as MatDatepickerInputEvent<Date>)
      }
    }
    //get time slot
    if (this.product?.timeSelectionRequired && selectedDate) {
      this.grpSalesTimeSlot = new Set<string>();

      const time = this.extractTimeSlotFromDate(selectedDate);
      this.grpSalesTimeSlot.add(time);
      this.groupRuleCartForm.get('timeSlotPicker')?.setValue(time);
    }
  }


  private extractTimeSlotFromDate(selectedDate: string) {
    const date = new Date(selectedDate);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour format to 12-hour format
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }
  getAddonFormControlsFields() {
    const formGroupFields = {} as string | any;
    if (this.product.groupRuleAddonMealProduct && this.product.groupRuleAddonMealProduct.variantOptions) {
      this.product.groupRuleAddonMealProduct.variantOptions.forEach((variant) => {
        const controlName = variant.code + '#mealAddon';
        const qty = this.stepperBtnDisabled(variant.stock)
          ? 0
          : variant.selectedQuantity
          ? variant.selectedQuantity
          : 0;
        formGroupFields[controlName] = new UntypedFormControl({
          value: qty,
          disabled: this.stepperBtnDisabled(variant.stock),
        });
      });
    } else {
      const qty = this.stepperBtnDisabled(this.product.groupRuleAddonMealProduct?.stock)
        ? 0
        : this.product.groupRuleAddonMealProduct?.selectedQuantity
        ? this.product.groupRuleAddonMealProduct?.selectedQuantity
        : 0;
      formGroupFields['mealAddon'] = new UntypedFormControl({
        value: qty,
        disabled: this.stepperBtnDisabled(this.product.groupRuleAddonMealProduct?.stock),
      });
    }
    if (this.product.groupRuleAddonProduct && this.product.groupRuleAddonProduct.variantOptions) {
      this.product.groupRuleAddonProduct.variantOptions.forEach((variant) => {
        const controlName = variant.code + '#addonProduct';
        const qty = this.stepperBtnDisabled(variant.stock)
          ? 0
          : variant.selectedQuantity
          ? variant.selectedQuantity
          : 0;
        formGroupFields[controlName] = new UntypedFormControl({
          value: qty,
          disabled: this.stepperBtnDisabled(variant.stock),
        });
      });
    } else {
      const qty = this.stepperBtnDisabled(this.product.groupRuleAddonProduct?.stock)
        ? 0
        : this.product.groupRuleAddonProduct?.selectedQuantity
        ? this.product.groupRuleAddonProduct?.selectedQuantity
        : 0;
      formGroupFields['addonProduct'] = new UntypedFormControl({
        value: qty,
        disabled: this.stepperBtnDisabled(this.product.groupRuleAddonProduct?.stock),
      });
    }
    if (this.product.dateSelectionRequired) {
    formGroupFields['groupRuleDatePicker'] = new UntypedFormControl();
    }
    if (this.product.timeSelectionRequired) {
      formGroupFields['timeSlotPicker'] = new UntypedFormControl('');
    }
    return formGroupFields;
  }

  onGroupRuleQuantityChange(quantity: number, code: string) {
    if (this.shouldDisableDateSelection()) {
      this.groupRuleCartForm?.get('groupRuleDatePicker')?.disable();
    } else {
      this.groupRuleCartForm?.get('groupRuleDatePicker')?.enable();
      this.groupRuleCartForm?.get('groupRuleDatePicker')?.reset();
      this.isAddToCartDisabled = true;
    }
    this.dataTransfer.setGroupProdQuantityAndTotal(quantity, code, this.product);
  }

  groupRuleAddToCart() {
    let orderID = this.route.snapshot.queryParamMap.get('orderId');
    this.apiLoading$.next(true);

    if (!this.usjfeature){
    this.calcVisitDateNA();
    }
    this.sub$.add(
      this.groupSales.addGroupRuleProductToCart(this.product, this.selectedVisitaionDate, orderID).subscribe((res) => {
        this.apiLoading$.next(false);
        if (res.orderCode) {
          this._router.navigate(['/group-checkout'], { queryParams: { orderId: res.orderCode } });
        } else {
          // Raj: Error message is already displayed in handleGroupRuleAddToCart() method of udx-group-sales.service.ts
          /*this.globalMessageService.add(
            { key: 'groupSalesPDP.httpHandlers.pdpAddToCart' },
            GlobalMessageType.MSG_TYPE_ERROR
          );*/
        }
      })
    );
  }

  private calcVisitDateNA() {
    if (this.product?.dateSelectionRequired) {
      var date = this.groupRuleCartForm?.controls['groupRuleDatePicker']?.value;
      if (date) {
        this.selectedVisitaionDate = moment(date).format('MM/DD/YYYY');
      }
    }
    if (this.product?.timeSelectionRequired) {
      const timeSlot = this.groupRuleCartForm?.controls['timeSlotPicker']?.value;
      if (timeSlot) {
        this.selectedVisitaionDate = this.selectedVisitaionDate + ' ' + timeSlot;
      }
    }
    else {
      if (this.grpSalesTimeSlot.size === 1) {
        this.grpSalesTimeSlot.forEach((time) => {
          this.selectedVisitaionDate = this.selectedVisitaionDate + ' ' + time;
        });
      }
    }
    if (this.visitationDate) {
      this.selectedVisitaionDate = this.visitationDate;
    }
  }

  override dateSelected(date: MatDatepickerInputEvent<Date>) {
    if (date.value) {
      this.visitationDate = '';
      this.addToCartForm.get('datePicker')?.setValue(date.value, { emitEvent: false });
      this.isAddToCartDisabled = false;
      this.grpSalesTimeSlot = new Set<string>();
      if (this.product.timeSelectionRequired) {
        this.groupRuleCartForm?.get('timeSlotPicker')?.reset();
        this.groupRuleCartForm?.get('timeSlotPicker')?.enable();
        this.isAddToCartDisabled = true;
      }
      if (this.usjfeature){
        this.selectedVisitaionDate = this.dateToString(new Date(date.value))/* + ' 09:00:00'*/; // Raj: USJCOMM-9656: Timeslot was mandatory in USJ, it's not in GTA.
      }
      const formatedDateForTotalCal = this.dateToString(new Date(date.value)).trim();
      this.caluclateTotalForSelectedDate(this.updatedQuantityMap, formatedDateForTotalCal);
    } else {
      this.isAddToCartDisabled = true;
    }
  }

   override getDefaultPerfomance():string{
    if (this.grpSalesTimeSlot.size === 1 ){
      const [first] = this.grpSalesTimeSlot;
      return first;
    }
  return '';
  }
  caluclateTotalForSelectedDate(quantityMap: Map<string, number>, selectedDate: string) {
    let total = 0;
    quantityMap.forEach((value, key) => {
      const partNumber = key.includes('#mealAddon')
        ? key.split('#mealAddon')[0]
        : key.includes('#addonProduct')
        ? key.split('#addonProduct')[0]
        : key;
      const calendarDates = this.availableTimeSlotAndPrice.get(partNumber);
      if (calendarDates != undefined) {
        const pricing = calendarDates
          .filter((cal: { date: string }) => cal.date === selectedDate)
          .flatMap((obj: { pricing: [] }) => obj.pricing);

        //get time slot

        this.grpSalesTimeSlotEvent(calendarDates, selectedDate);

        // }

        total = total + pricing[0]?.amount * value;
      }
    });
    this.dataTransfer.updateGroupRuleSubtotal(total);
  }

  private grpSalesTimeSlotEvent(calendarDates: any, selectedDate: string) {
    const timeslot = calendarDates
      .filter((cal: { date: string; }) => cal.date === selectedDate)
      .flatMap((obj: { inventoryEvents: []; }) => obj.inventoryEvents);

      timeslot.forEach((time: Udxb2bInventoryEvents) => {
        this.extractgrpSalesTimefromStartDate(time);
      });

      if (this.grpSalesTimeSlot.size === 1) {
        const [first] = this.grpSalesTimeSlot;
        this.groupRuleCartForm?.get('timeSlotPicker')?.setValue(first);
      }

  }

  private extractgrpSalesTimefromStartDate(time: Udxb2bInventoryEvents) {
    var timeAndDate = time.startDate!.split(/(\s+)/);
    if (timeAndDate[2] && timeAndDate[4]) {
      this.grpSalesTimeSlot.add(timeAndDate[2] + ' ' + timeAndDate[4]);
    }
  }
  override onPickerToggle() {
    if (!this.product.calendarStartDate || !this.product.calendarEndDate) {
      // USJT-15092: Change max date here - Get the max date of the variant with highest date and min date with the variant having lowest date
      const variantOptions = this.product.variantOptions || [];

      // Get all valid start dates
      const variantStartDates = variantOptions
        .map(v => v?.calendarStartDate)
        .filter((date): date is string => typeof date === 'string' && date.trim() !== '')
        .map(date => new Date(date));

      const lowestDate =
        variantStartDates.length > 0
          ? new Date(Math.min(...variantStartDates.map(d => d.getTime())))
          : this.minDate;

      // Get all valid end dates
      const variantEndDates = variantOptions
        .map(v => v?.calendarEndDate)
        .filter((date): date is string => typeof date === 'string' && date.trim() !== '')
        .map(date => new Date(date));

      const highestDate =
        variantEndDates.length > 0
          ? new Date(Math.max(...variantEndDates.map(d => d.getTime())))
          : this.maxDate;

      this.minDate = lowestDate;
      this.maxDate = highestDate;

      this.product.calendarStartDate = this.dateToString(this.minDate);
      this.product.calendarEndDate = this.dateToString(this.maxDate);
    }
    this.dataTransfer.quantityData$.pipe(take(1)).subscribe((quantityMap: Map<string, number>) => {
      this.updatedQuantityMap = new Map(quantityMap);
      let mainProductQty: number = 0;
      let addonProdQty: number = 0;
      let disableDateSelection: boolean = false;
      this.updatedQuantityMap.forEach((value, key) => {
        if (key.includes('#mealAddon') || key.includes('#addonProduct')) {
          addonProdQty = addonProdQty + value;
        } else {
          mainProductQty = mainProductQty + value;
        }
      });
      if (addonProdQty === 0 && mainProductQty === 0) {
        disableDateSelection = true;
        this.globalMessageService.add({ key: 'groupSalesPDP.noproductselected' }, GlobalMessageType.MSG_TYPE_WARNING);
      } else if (mainProductQty === 0 && addonProdQty > 0) {
        disableDateSelection = true;
        this.globalMessageService.add(
          { key: 'groupSalesPDP.mainproductNotSelected' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      } else if (mainProductQty < this.product.groupRuleMinQty! || mainProductQty > this.product.groupRuleMaxQty!) {
        disableDateSelection = true;
        const params = { min: this.product.groupRuleMinQty, max: this.product.groupRuleMaxQty };
        this.globalMessageService.add({ key: 'groupSalesPDP.quantityerror', params }, GlobalMessageType.MSG_TYPE_ERROR);
      } else {
        super.onPickerToggle();
      }
      if (disableDateSelection) {
        this.dateFilter = (date: any): boolean => {
          return false;
        };
      }
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
  }

  isEmptyObject(obj: any): boolean {
    return JSON.stringify(obj) === '{}';
  }

  getMaxNumber() {
    return Number.MAX_SAFE_INTEGER;
  }
  checkAndDisableDateSelection() {
    if (this.shouldDisableDateSelection()) {
      this.groupRuleCartForm?.get('groupRuleDatePicker')?.disable();
    } else {
      this.groupRuleCartForm?.get('groupRuleDatePicker')?.enable();
    }
  }
  shouldDisableDateSelection() {
    var shouldDisableDateSelection = false;
    if (this.product.isSavedGroupCart) {
      shouldDisableDateSelection = true;
    }
    return shouldDisableDateSelection;
  }
}

function addOneDay(date = new Date()) {
  date.setDate(date.getDate() + 1);
  return date;
}
